import { CollaborationStatus, CompletionReason } from '@99designs/graph-utils/types';
import { __ } from '@99designs/i18n';

export function getProjectDescription(
    displayStatus: CollaborationStatus | undefined,
    completionReason?: CompletionReason | null
): string {
    if (!displayStatus) return '';

    switch (displayStatus) {
        case 'COLLABORATION_STATUS_REQUEST_SUBMITTED':
            return __(
                "Hi there! We'll begin working on your design soon. You will be notified by email when your design is ready for review."
            );

        case 'COLLABORATION_STATUS_DESIGN_IN_PROGRESS':
            return __(
                "We have started working on your request! You'll receive your first round of designs to review shortly."
            );

        case 'COLLABORATION_STATUS_REVISION_IN_PROGRESS':
            return __(
                'Feedback has been shared. The designer will begin working on revisions soon. An email will be sent once the updated design is ready.'
            );

        case 'COLLABORATION_STATUS_READY_FOR_REVIEW':
            return __(
                "I'm excited to share what I've created for you. Please take a look and let me know what you think."
            );

        case 'COLLABORATION_STATUS_APPOINTMENT_SCHEDULED':
            return __(
                "We'll begin working on your design soon. Your Zoom link to join the session has been emailed to you and is available here."
            );

        case 'COLLABORATION_STATUS_APPOINTMENT_IN_SESSION':
            return __('Please enter your design live session to meet your designer.');

        case 'COLLABORATION_STATUS_APPOINTMENT_PREPARING':
            return __(
                "Your designer has started working on your request! We're looking forward to working with you on your designs during your live session."
            );

        case 'COLLABORATION_STATUS_CLOSED':
            return __('This project is now closed and revisions can no longer be requested.');

        case 'COLLABORATION_STATUS_REVISIONS_COMPLETE':
            return __('The project is now completed.');

        case 'COLLABORATION_STATUS_DESIGN_APPROVED':
            return __('Your design has been approved and your project has been completed.');

        case 'COLLABORATION_STATUS_COMPLETE':
            switch (completionReason) {
                case 'COMPLETION_REASON_INACTIVITY':
                    return __('Your project has been completed due to inactivity.');
                case 'COMPLETION_REASON_REVISIONS_EXHAUSTED':
                    return __(
                        'Your project has been completed because all revisions have been used.'
                    );
                case 'COMPLETION_REASON_APPROVAL':
                    return __('Your design has been approved and your project has been completed.');
                case 'COMPLETION_REASON_PRINT':
                    return __('Your design has been printed and your project has been completed.');
                default:
                    return __('The project is now completed.');
            }
        default:
            return '';
    }
}
